export const SCHOOL_TYPE = 'school';
export const KINDERGARTEN_TYPE = 'kindergarten';

export const ownerType = (type) => (type === KINDERGARTEN_TYPE ? 'barnehage' : 'skole');

export const mapSchoolToFrontend = ({ school }) => {
    if (!school) {
        return null;
    }

    return {
        id: school.id,
        organizationNumber: school.organization_number,
        name: school.name,
        address: school.location,
        email: school.email,
        studentCount: school.student_count,
        updatedAt: school.updated_at,
        createdAt: school.created_at,
        schoolClass: school.school_class,
    };
};

export const mapSchoolFromUdir = (school) => {
    if (!school) {
        return null;
    }

    return {
        organizationNumber: school.Orgnr,
        name: school.Karakteristikk ? `${school.Navn} - ${school.Karakteristikk}` : school.Navn,
        address: {
            postalCode: school.Beliggenhetsadresse?.Postnr,
            postalName: school.Beliggenhetsadresse?.Poststed,
            address: school.Beliggenhetsadresse?.Adresse,
            latitude: school.Koordinat?.Breddegrad,
            longitude: school.Koordinat?.Lengdegrad,
        },
        email: school.Epost,
        studentCount: school.Elevtall,
        updatedAt: school.DatoEndret,
        createdAt: school.DatoFoedt,
    };
};

export const getSchoolSearchProfileElementFromSchoolType = (schoolType) => {
    if (schoolType === SCHOOL_TYPE) {
        return { schoolSearch: true };
    } else if (schoolType === KINDERGARTEN_TYPE) {
        return { kindergartenSearch: true };
    } else {
        return {};
    }
};
